import { getZrmUserInfo, type ZrmClickstreamUser } from '@zg-rentals/clickstream';

import { trackEvent } from '../analytics/index';

const EVENT_IDS = {
  CLICK_NAVIGATION_LINK: '6039',
  ON_PROPERTIES_DROPDOWN_OPEN: '7661',
  CLICK_ADD_PROPERTY_FROM_DROPDOWN_MENU: '7662',
  CLICK_ADD_FEED_FROM_DROPDOWN_MENU: '7663',
} as const;

// https://dataportal.zillowgroup.net/event-registry/7663
const ClickAddFeedFromDropdownMenu = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_ADD_FEED_FROM_DROPDOWN_MENU,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_left_nav',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'zrm_left_nav',
      trigger_source_nm: 'add_feed_link',
    },
    semantic: {
      semantic_event_nm: 'open_add_property_modal',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7662
const ClickAddPropertyFromDropdownMenu = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_ADD_PROPERTY_FROM_DROPDOWN_MENU,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_left_nav',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'zrm_left_nav',
      trigger_source_nm: 'add_property_link',
    },
    semantic: {
      semantic_event_nm: 'open_add_property_modal',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6039
const ClickNavigationLink = ({ user, link }: { user: ZrmClickstreamUser; link: string }) =>
  trackEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CLICK_NAVIGATION_LINK,
      event_type_version_id: '3',
    },
    clickstream_trigger: {
      trigger_location_nm: 'navigation',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: link,
    },
    semantic: {
      semantic_event_nm: 'nav_click',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7661
const OnPropertiesDropdownOpen = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.ON_PROPERTIES_DROPDOWN_OPEN,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_left_nav',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'zrm_left_nav',
      trigger_source_nm: 'open_add_tray',
    },
    semantic: {
      semantic_event_nm: 'open_add_feed_modal',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

const HeaderNavigationClickstreamEvents = {
  ClickAddFeedFromDropdownMenu,
  ClickAddPropertyFromDropdownMenu,
  ClickNavigationLink,
  OnPropertiesDropdownOpen,
};

// Clickstream visualizer data-eventid attributes
ClickAddFeedFromDropdownMenu.data_event_id = EVENT_IDS.CLICK_ADD_FEED_FROM_DROPDOWN_MENU;
ClickAddPropertyFromDropdownMenu.data_event_id = EVENT_IDS.CLICK_ADD_PROPERTY_FROM_DROPDOWN_MENU;
ClickNavigationLink.data_event_id = EVENT_IDS.CLICK_NAVIGATION_LINK;
OnPropertiesDropdownOpen.data_event_id = EVENT_IDS.ON_PROPERTIES_DROPDOWN_OPEN;

export default HeaderNavigationClickstreamEvents;
